import React, { useState } from 'react';
import { Input, Select, Spin } from 'antd';
import strings from '../../strings/strings.json';
import IpInput from 'components/ip_input';
import { connectToWired } from 'api/api_service';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";

export default function Ethernet() {
    const [ipAddress, setIpAddress] = useState<string>()
    const [subnet, setSubnet] = useState<string>()
    const [gateway, setGateway] = useState<string>()
    const [DNS, setDNS] = useState<string>()
    const [alerDNS, setAlterDNS] = useState<string>()
    const [connectLoading, setConnectLoading] = useState(false)
    const dispatch = useDispatch()

    const submitHandler = () => {
        let obj: any = {}
        if (!ipAddress &&
            !subnet &&
            !gateway &&
            !DNS &&
            !alerDNS) {
            obj["dhcp"] = true
            connectHandler(obj)

        } else if (ipAddress &&
            subnet &&
            gateway &&
            DNS &&
            alerDNS) {
            if (checkSubnetFornmat(subnet)) {
                obj["dhcp"] = false
                obj["ip"] = ipAddress
                obj["subnet"] = checkSubnetFornmat(subnet)
                obj["gw"] = gateway
                obj["dnsp"] = DNS
                obj["dnsa"] = alerDNS
                connectHandler(obj)
            } else {
                dispatch(showSnackbar({ "open": true, 'severity': 'warning', 'msg': `${strings.internet_subnetNotValid}` }));
            }
        } else {
            dispatch(showSnackbar({ "open": true, 'severity': 'warning', 'msg': `${strings.public_enterAll}` }));
        }

    }

    const checkSubnetFornmat = (subnet: string) => {
        switch (subnet) {
            case "255.255.255.255":
                return "32"
            case "255.255.255.254":
                return "31"
            case "255.255.255.252":
                return "30"
            case "255.255.255.248":
                return "29"
            case "255.255.255.224":
                return "27"
            case "255.255.255.192":
                return "26"
            case "255.255.255.128":
                return "25"
            case "255.255.255.0":
                return "24"
            case "255.255.254.0":
                return "23"
            case "255.255.252.0":
                return "22"
            case "255.255.248.0":
                return "21"
            case "255.255.240.0":
                return "20"
            case "255.255.224.0":
                return "19"
            case "255.255.192.0":
                return "18"
            case "255.255.128.0":
                return "17"
            case "255.255.0.0":
                return "16"
            case "255.254.0.0":
                return "15"
            case "255.252.0.0":
                return "14"
            case "255.248.0.0":
                return "13"
            case "255.240.0.0":
                return "12"
            case "255.224.0.0":
                return "11"
            case "255.192.0.0":
                return "10"
            case "255.128.0.0":
                return "9"
            case "255.0.0.0":
                return "8"
            default:
                return ''
        }
    }

    const connectHandler = (obj: object) => {
        setConnectLoading(true)
        connectToWired(obj)
            .then(res => {
                setConnectLoading(false)
                if (res.status === 200 && res.data.success) {
                    dispatch(showSnackbar({ "open": true, 'severity': 'success', 'msg': `${strings.public_connectSuccessful}` }));
                } else {
                    dispatch(showSnackbar({ "open": true, 'severity': 'error', 'msg': `${strings.public_error}` }));
                }
                setIpAddress('')
                setSubnet('')
                setGateway('')
                setDNS('')
                setAlterDNS('')
            })
            .catch(err => {
                setConnectLoading(false)
                if (err.response.data.error_code === 96) {
                  dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.demo_error }));
                }  else {
                   dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
               }
            })
    }

    return (
        <div className='lg:h-72 lg:overflow-y-scroll'>
            <div className='border border-gray-100 rounded-lg mt-8 p-5'>
                {
                    connectLoading ?
                        <div className='flex justify-center items-center mt-20 mb-20'>
                            <Spin size='large' />
                        </div>
                        :
                        <div className='grid grid-cols-2'>
                            <div className='flex justify-between mx-5 mt-5 col-span-2 md:col-span-1'>
                                <span className='primary_text_color font-medium'>{strings.settings_ipAddress}</span>
                                <div><IpInput placeholder='IP Address' ipValue={(ip) => setIpAddress(ip)} /></div>
                            </div>
                            <div className='flex justify-between mx-5 mt-5 col-span-2 md:col-span-1'>
                                <span className='primary_text_color font-medium'>{strings.settings_subnet}</span>
                                <div><IpInput placeholder='Subnet Mask' ipValue={(ip) => setSubnet(ip)} /></div>
                            </div>
                            <div className='flex justify-between mx-5 mt-5 col-span-2 md:col-span-1'>
                                <span className='primary_text_color font-medium'>{strings.settings_gateway}</span>
                                <div><IpInput placeholder='Gateway Address' ipValue={(ip) => setGateway(ip)} /></div>
                            </div>
                            <div className='flex justify-between mx-5 mt-5 col-span-2 md:col-span-1'>
                                <span className='primary_text_color font-medium'>{strings.settings_addressServer}</span>
                                <div><IpInput placeholder='DNS Server' ipValue={(ip) => setDNS(ip)} /></div>
                            </div>
                            <div className='flex justify-between mx-5 mt-5 col-span-2 md:col-span-1'>
                                <span className='primary_text_color font-medium'>{strings.settings_secondAddressServer}</span>
                                <div><IpInput placeholder='Alternative DNS Server' ipValue={(ip) => setAlterDNS(ip)} /></div>
                            </div>
                        </div>
                }
            </div>
            <div className='mt-5'>
                <span className='primary_text_color text-xs font-bold'>{strings.settings_DHCPWarning}</span>
                <button
                    className='flex text-white rounded-full px-8 py-3 primary_bg_color mt-1'
                    onClick={() => submitHandler()}>
                    <span>{strings.settings_save}</span>
                </button>
            </div>
        </div>
    )
}
